export * from "/builds/dd3tech/wiggot/wiggot-web/packages/web-components/store/modals/modal-add-list.store.ts"